import { Badge } from './ui/badge';

const MAX_VISIBLE_DEPARTMENTS = 2;

interface UserDepartmentLink {
  departments: { id: number; name: string };
}

interface UserDepartmentsCellProps {
  userDepartments: UserDepartmentLink[];
}

export default function UserDepartmentsCell({
  userDepartments,
}: UserDepartmentsCellProps) {
  const departments = userDepartments
    .map((link) => link.departments)
    .filter(Boolean);

  if (departments.length === 0) {
    return <span className="text-muted-foreground">—</span>;
  }

  const visible = departments.slice(0, MAX_VISIBLE_DEPARTMENTS);
  const overflowCount = departments.length - visible.length;
  const allNames = departments.map((dept) => dept.name).join(', ');

  return (
    <div className="flex flex-wrap gap-1" title={allNames}>
      {visible.map((dept) => (
        <Badge key={dept.id} variant="outline">
          {dept.name}
        </Badge>
      ))}
      {overflowCount > 0 && (
        <Badge variant="outline">+{overflowCount} more</Badge>
      )}
    </div>
  );
}
